import React from 'react';
import DragonsContainer from '../components/DragonsContainer';

const Dragons = () => (
  <>
    <DragonsContainer />
  </>
);

export default Dragons;
